export enum ParticipantDeviceAssessmentDisplayVariant {
	Examiner = "examiner",
	Student = "student",
	SP = "sp",
}
